import { confirmDialog, ConfirmDialogProps } from "primereact/confirmdialog";
import { IconType } from "primereact/utils";

import { faExclamationTriangle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { translationKeys } from "../../../models/app-translation-keys";

interface IConfirmActionDialogProps {
  header?: string;
  message?: string;
  acceptLabel?: string;
  rejectLabel?: string;
  acceptClassName?: string;
  rejectClassName?: string;
  icon?: IconType<ConfirmDialogProps>;
  defaultFocus?: "accept" | "reject";
  dismissableMask?: boolean;
}

export const confirmAction = async (
  translationFunction: (key: string) => string,
  props?: IConfirmActionDialogProps,
): Promise<boolean> => {
  return new Promise(resolve => {
    confirmDialog({
      header: props?.header || translationFunction(translationKeys.dialog.confirm.header),
      message: props?.message || translationFunction(translationKeys.dialog.confirm.message),
      icon: props?.icon || <FontAwesomeIcon icon={faExclamationTriangle} />,
      defaultFocus: "reject",
      dismissableMask: props?.dismissableMask,
      acceptClassName: props?.acceptClassName ?? "p-button-danger",
      rejectClassName: props?.rejectClassName,
      acceptLabel: props?.acceptLabel || translationFunction(translationKeys.dialog.confirm.acceptLabel),
      rejectLabel: props?.rejectLabel || translationFunction(translationKeys.dialog.confirm.rejectLabel),
      accept: () => resolve(true),
      reject: () => resolve(false),
    });
  });
};
